import * as React from "react";
import { Col, Row } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import useHistory from "routing/useHistory";
import AIManagementRoutes from "ai-management/Routes";
import AIManagementPageNavigation from "ai-management/AIManagementPageNavigation";
import ModelProviderForm from "ai-management/model-providers/form/ModelProviderForm";
const CreateModelProviderPage = () => {
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Create model provider" }, /* @__PURE__ */ React.createElement(AIManagementPageNavigation, null), /* @__PURE__ */ React.createElement(PageHeader, { title: "Create model provider" }, /* @__PURE__ */ React.createElement("span", null, "Connect AI features to a provider such as OpenAI or Anthropic. Test the connection to load the provider's models, then choose the default model of this model provider.")), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(
    ModelProviderForm,
    {
      onSaved: (id) => history.push(AIManagementRoutes.modelProviderEdit(id)),
      onCancel: () => history.push(AIManagementRoutes.MODEL_PROVIDERS)
    }
  ))));
};
export default CreateModelProviderPage;
